import React from 'react';
import mainLogo from '../../assets/icons/Logo.svg';

interface ResellerBrandingProps {
  logoUrl?: string;
  resellerName?: string;
  showPartnerText?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const ResellerBranding: React.FC<ResellerBrandingProps> = ({
  logoUrl,
  resellerName,
  showPartnerText = false,
  size = 'medium'
}) => {
  const sizeClasses = {
    small: 'h-8',
    medium: 'h-12',
    large: 'h-16'
  };

  return (
    <div className="reseller-branding">
      <img
        src={logoUrl || mainLogo}
        alt={resellerName ? `${resellerName} Logo` : 'TruHu Logo'}
        className={`reseller-branding__logo ${sizeClasses[size]}`}
        onError={(e) => {
          (e.target as HTMLImageElement).src = mainLogo;
        }}
      />
      {showPartnerText && resellerName && (
        <span className="reseller-branding__partner-text">
          Provided by {resellerName}
        </span>
      )}
    </div>
  );
};

export default ResellerBranding;
